// OFFLINE PAYMENT FORM ACTIONS
require('es6-promise').polyfill()
require('isomorphic-fetch')

export const RETRIEVE_BANKS_PATH = "../banks"

const OFFLINE_PAYMENT_FORM = '[Offline Payment Form]'
export const CHANGE_FULLNAME = `${OFFLINE_PAYMENT_FORM} Change Full Name`
export const VALIDATE_FULLNAME = `${OFFLINE_PAYMENT_FORM} Validate Full Name`
export const CHANGE_DOCUMENT_NUMBER = `${OFFLINE_PAYMENT_FORM} Change Document Number`
export const VALIDATE_DOCUMENT_NUMBER = `${OFFLINE_PAYMENT_FORM} Validate Document Number`
export const CHANGE_EMAIL = `${OFFLINE_PAYMENT_FORM} Change Email`
export const VALIDATE_EMAIL = `${OFFLINE_PAYMENT_FORM} Validate Email`
export const CHANGE_BANK = `${OFFLINE_PAYMENT_FORM} Change Bank`
export const FETCH_BANKS = `${OFFLINE_PAYMENT_FORM} Fetch Banks`
export const FETCH_BANKS_SUCCESS = `${OFFLINE_PAYMENT_FORM} Fetch Banks Success`
export const FETCH_BANKS_FAILURE = `${OFFLINE_PAYMENT_FORM} Fetch Banks Failure`

/**
 * These are the actions that are designed to operate the Offline Payment Form
 */
export const OfflinePaymentFormActions = {
    /**
     * Dispatches the action of changing the full name of the User currently in the Offline Payment Form.
     *
     * @param fullName {String} : The new full name.
     * @param shouldValidate {Boolean} : Determines whether there should be triggered the validation of the full name
     * and dispatch the action that reflects the effects of it.
     */
    changeFullName: (fullName, shouldValidate = false) => dispatch => {
        let action = createAction(CHANGE_FULLNAME, {
            fullName: fullName.toUpperCase()
        })

        dispatch(action)

        if (!shouldValidate) {
            return
        }

        action = createAction(VALIDATE_FULLNAME, {
            fullNameError: fullName === null || fullName.length === 0 ? "Completa este dato" : ""
        })

        dispatch(action)
    },

    /**
     * Dispatches the action of changing the document number of the User currently in the Offline Payment Form.
     *
     * @param documentTypes {Object} : The map with the allowed document types.
     * @param documentType {String} : The selected document type.
     * @param documentNumber {String} : The selected document number.
     * @param shouldValidate {Boolean} : Determines whether there should be triggered the validation of the document
     * number and dispatch the action that reflects the effects of it.
     */
    changeDocument: (documentTypes, documentType, documentNumber, shouldValidate = false) => dispatch => {
        documentNumber = (documentNumber !== null && documentNumber !== undefined) ? documentNumber.toUpperCase() : ""

        let action = createAction(CHANGE_DOCUMENT_NUMBER, {
            documentType,
            documentNumber: documentNumber.toUpperCase(),
        })

        dispatch(action)

        if (!shouldValidate) {
            return
        }

        let error = "",
            regularExpression = /^\d{7,8}$/

        if (documentNumber === null || documentNumber.length === 0) {
            error = "Completa este dato"
        } else if (!regularExpression.test(documentNumber)) {
            error = "Encontramos un error en este dato"
        }

        action = createAction(VALIDATE_DOCUMENT_NUMBER, {
            documentNumberError: error
        })

        dispatch(action)
    },

    changeBank: (bank) => dispatch => {
        let action = createAction(CHANGE_BANK, {
            bank: bank,
        })

        dispatch(action)
    },

    changeEmail: (email, shouldValidate = false) => dispatch => {
        email = (email !== null && email !== undefined) ? email.toLowerCase() : ""

        let action = createAction(CHANGE_EMAIL, {
            email: email,
        })

        dispatch(action)

        if (!shouldValidate) {
            return
        }

        let error = "",
            isValidEmail = validateEmail(email)

        if (email === null || email.length === 0) {
            error = "Completa este dato"
        } else if (!isValidEmail) {
            error = "Encontramos un error en este dato. Ingresa un email válido."
        }

        action = createAction(VALIDATE_EMAIL, {
            emailError: error
        })

        dispatch(action)
    },

    fetchBanks: (apikey, consumerUsername) => dispatch => {
        const getBanksUrl = RETRIEVE_BANKS_PATH;

        let headers = {};

        if (`${process.env.NODE_ENV}` === 'development') {
            headers = {
                'Content-Type': 'application/json',
                'X-Consumer-Username': consumerUsername
            }
        } else {
            headers = {
                'Content-Type': 'application/json',
                'apikey': apikey
            }
        }

        let action = createAction(FETCH_BANKS)
        dispatch(action)

        fetch(getBanksUrl, {
            headers
        }).then((response) => {
            return response.json()
        })
            .then(function (banks) {
                let action = createAction(FETCH_BANKS_SUCCESS, {banks})
                dispatch(action)

            })
            .catch(err => {
                    let action = createAction(FETCH_BANKS_FAILURE, {err})
                    dispatch(action)
                }
            )
    }

}

function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


function createAction(type, actionParameters = {}) {
    return {type, ...actionParameters}
}
